﻿import {EventLogGateway} from './eventLog.gateway';
import * as LogService from "../../core/services/logservice/log.service";
import * as Model from '../../models/models';
import {ScreenLockService} from "../../core/services/screenLockService/screenLock.service";
import {ViewLockService} from "../../core/services/viewLockService/viewLock.service";
import EventLogmodel = require("../../models/eventLog.model");
import IEventLog = EventLogmodel.IEventLog;

export class EventLogDetailController {
    private viewModel: Model.IEventLog;

    private isDataGridLoading: boolean;

    static $inject = ['$uibModal', '$state', '$stateParams', 'logService', 'eventLog.gateway', 'screenLockService', 'viewLockService'];

    constructor(private $modal: any,
        private $state: ng.ui.IStateService,
        private params: IEventLogDetailsParams,
        private logger: LogService.ILogService,
        private eventLogGateway: EventLogGateway,
        private screenLockService: ScreenLockService,
        private viewLockService: ViewLockService
    ) {
        this.activate();
    }

    private activate(): void {
        this.viewLockService.broadcast(1);

        const eventLogPromise: ng.IPromise<IEventLog> = this.eventLogGateway.getEventLog(this.params.eventLogId);

        eventLogPromise.then((searchResults: IEventLog) => {
            this.logger.debug("eventLogPromise", searchResults);
            this.viewModel = searchResults;
        }).finally(() => {
            this.viewLockService.broadcast(0);
            //screenLock may turn off before viewLock due to logic in delay function since the viewLockStartTime and screenLockStartTime are isolated
            this.screenLockService.broadcast(0);
        });
    }

    public return(): void {
        this.$state.go('shellFrame.administrationFrame.eventLog');
    }
}